import { ISession } from '../models/pro-sites';
import * as CON from '../components/common/constants';
export const agreementDisplayCheck = (session: ISession) => {
    //if another country does NOT want agreements to display, add here
    if (CON.noAgreementCountries.includes(session.country)) {
        return false;
    } else if (session.selectedBrand === CON.MIRACLEEAR) {
        return false;
    }
    return true;
};
